import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormGroupDirective, Validators} from '@angular/forms';
import {HvAntragComponent} from '../../antrag/hv-antrag/hv-antrag.component';
import {IHvProdukt} from '../../../models/hvprodukt';
import {IHvResult} from '../../../models/hvresult';
import {ZusammenfassungService} from '../../../service/zusammenfassung.service';
import {AntragWeitereFragenComponent} from '../../antrag/antrag-weitere-fragen/antrag-weitere-fragen.component';
import {DataService} from '../../../service/data.service';
import {IHvPaket} from '../../../models/hvpaket';
import {HeimvorteilGebaeudeart, HeimvorteilProduktart} from '../../../../shared/enum';
import { DatenschutzPolicyComponent } from '../../datenschutz-policy/datenschutz-policy.component';
import { AppTextareaComponent } from '../../app-textarea/app-textarea.component';
import { VereinbarungKommunikationComponent } from '../../vereinbarung-kommunikation/vereinbarung-kommunikation.component';

@Component({
  selector: 'app-hv-zusammenfassung',
  templateUrl: './hv-zusammenfassung.component.html',
  styleUrls: ['./hv-zusammenfassung.component.scss']
})
export class HvZusammenfassungComponent {
  @Input()
  parentFormGroupDirective: FormGroupDirective;

  @Input()
  formGroup: UntypedFormGroup;

  @Input()
  produkt: IHvProdukt;

  @Input()
  hvAntragComponent: HvAntragComponent;

  @Input()
  weitereFragen: AntragWeitereFragenComponent;

  @Input()
  hvResult: IHvResult;

  @Input()
  expertMode: boolean;

  @Input()
  produktart: HeimvorteilProduktart;

  @Input()
  gebaeudeart: HeimvorteilGebaeudeart;

  @Input()
  datenschutzPolicyAntrag: DatenschutzPolicyComponent;

  @Output()
  korrekturEvent = new EventEmitter();

  heimvorteilProduktarten = HeimvorteilProduktart;

  @ViewChild('_besondereAnmerkungen') besondereAnmerkungenComponent: AppTextareaComponent;

  constructor(public zusammenfassungService: ZusammenfassungService, public dataService: DataService) { }

  static createFormGroup(fb: UntypedFormBuilder) {
    return fb.group({
      allgemeineVertragsgrundlagen: new UntypedFormControl('', Validators.requiredTrue),
      besondereAnmerkungen: new UntypedFormControl(''),
      vereinbarungKommunikation: VereinbarungKommunikationComponent.createVereinbarungKommunikation(),
    });
  }

  get nebenGebaeudeArten(){
    return this.dataService.hvNebenGebaeudeArten;
  }

  get Bauweisen(){
    return this.dataService.hvBauweisen;
  }

  get Einrichtungen(){
    return this.dataService.hvEinrichtungen;
  }

  get Dachungen(){
    return this.dataService.hvDachungen;
  }

  get GebaeudeTypen(){
    return this.dataService.hvGebaeudeTypen;
  }

  get Varianten(){
    return this.dataService.hvVarianten;
  }

  get allgemeineVertragsgrundlagen() { return this.formGroup.get('allgemeineVertragsgrundlagen'); }
  get besondereAnmerkungen() { return this.formGroup.get('besondereAnmerkungen'); }
  get vereinbarungKommunikation() { return this.formGroup.get('vereinbarungKommunikation'); }


  get showGebaeudeartWohnung() {
    return this.produktart === HeimvorteilProduktart.Haushalt &&
    this.gebaeudeart === HeimvorteilGebaeudeart.Wohnung ? true : false;
  }
  get showProduktHaushalt() {
    return this.produktart === HeimvorteilProduktart.Haushalt ||
    this.produktart === HeimvorteilProduktart.Buendel ? true : false;
  }
  get showProduktEigenheim() {
    return this.produktart === HeimvorteilProduktart.Eigenheim ||
    this.produktart === HeimvorteilProduktart.Buendel ? true : false;
  }
  get showProduktBuendel() {
    return this.produktart === HeimvorteilProduktart.Buendel ? true : false;
  }
  get isWohnung() {
    return this.produktart === 2 && this.gebaeudeart === 1;
  }

  get pakete(): IHvPaket[] {
    return (this.produkt.PaketeEigenheim ?? []).concat(this.produkt.PaketeHaushalt ?? []);
  }

  getVersicherungssummenText(paket: IHvPaket): string {
    return paket.Versicherungssummen.find( (x) => Number(x.Id) === paket.VersicherungssummeId ).Value;
  }

  getVersicherungssummenGeltungsbereichText(paket: IHvPaket): string {
    return paket.GeltungsbereicheVersicherungssummen.find( (x) => Number(x.Id) === paket.GeltungsbereicheVersicherungssummeId ).Value;
  }

  getSafeText(): string {
    const result = [];

    if(this.produkt.Erweiterungen.Unversperrt){
      result.push('unversperrt');
    }

    if(this.produkt.Erweiterungen.En0){
      result.push('EN0');
    }

    if(this.produkt.Erweiterungen.En1){
      result.push('EN1');
    }

    if(this.produkt.Erweiterungen.En2){
      result.push('EN2');
    }

    if(result.length === 0){
      result.push('nein');
    }

    return result.join(' / ');
  }
}
